import { render, staticRenderFns } from "./ManagePlan.vue?vue&type=template&id=637f6ed3&scoped=true"
import script from "./ManagePlan.vue?vue&type=script&lang=js"
export * from "./ManagePlan.vue?vue&type=script&lang=js"
import style0 from "./ManagePlan.vue?vue&type=style&index=0&id=637f6ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f6ed3",
  null
  
)

export default component.exports